exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "hr {\n  margin-top: 1.5rem;\n  border-top-color: #919191; }\n\np {\n  font-size: 15px;\n  margin-top: 0; }\n\n.btn {\n  width: 100px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-markets/dashboard-markets.component.scss
// module id = ../../../../../src/app/dashboard-markets/dashboard-markets.component.scss
// module chunks = main